import { ADD_VACANCY, FETCH_VACANCIES, EDIT_VACANCY, FETCH_VACANCIES_CANDIDATES, FIND_VACANCIES_STATUSES, SET_CANDIDATE_DETAILS, SET_USER_AVAILABILITY, UPDATE_CANDIDATE_INFO, SET_VACANCY_BY_ID, ADD_SEARCH, FETCH_SEARCHES, REMOVE_SEARCH, EDIT_SEARCH, FETCH_SEARCH_CANDIDATES, FETCH_SEARCH_SHORTLIST, UPDATE_SEARCH_SHORTLIST, FILTER_SEARCH_CANDIDATES, FETCH_BOT_TEMPLATE, EDIT_TEMPLATE, ADD_TEMPLATE, REMOVE_TEMPLATE, REMOVE_VACANCY, UPDATE_SNACKBAR, FETCH_VACANCIES_CANDIDATES_MONSTER, GET_VIEW_PREFS, REMOVE_VACANCIES_CANDIDATES } from "./types";
import _ from 'lodash';
import { fetchSkillTypes } from "./portal_actions";
import { post, patch, get } from "./api";
import { ConsoleLogger } from 'aws-amplify/utils';
import { getUrl } from "aws-amplify/storage";
const logger = new ConsoleLogger("VACANCIES.ACTIONS");


export const inviteToVacancy = (user, vacancy, status, shortlist) => {
  let body = {
    userId:  user.userID,
    jobId: vacancy.job_id,
    jobTitle: vacancy.job_title,
    jobDetails : {
      score_bp:user.skills,
      score_interest:user.interests,
      score_styles:user.styles,
      similar_skills: user.similar_skills,
      missing_skills: user.missing_skills
    }
  };
  if(vacancy.isProject){
    body.jobId = vacancy.sort
    body.isProject = true
  }
  else{
    body = {
      ...body,
      salary : Math.round(vacancy.annual_salary_min),
      employer: vacancy.employerName,
      location : vacancy.original_location === "Work from Home / Remote / Nationwide" ? "Work from Home / Remote / Nationwide": vacancy.location_full,
    }
    if (vacancy.hourly_salary_min){
      body.salary = vacancy.hourly_salary_min + " per hour"
    }
  } 

  if (status === "invited"){
    body.invited = true;
  } else if (status === "removed"){
    body.removed = true;
  } else if (status === "hired"){
    body.hired = true;
  } else if (status === "added"){
    body.added = true;
  }
  return async (dispatch) => {
    try {
      /*eslint-disable */
      let data = await post("/employer/job/user/status", body);
      /*eslint-enable */
      if(!shortlist){
        await dispatch({ type: UPDATE_CANDIDATE_INFO, data: body, status });
      }
      await dispatch(findAllStatuses(vacancy))
      await dispatch(fetchDetailedCandidate(body.userId, vacancy, true))
    } catch (e) {
      logger.error("inviteToVacancy():", e);
    }
  }
}


export const inviteListToVacancy = (userList, vacancy) => {
  return async (dispatch) => {
    let body = {
      userId:  null,
      jobId: vacancy.job_id,
      jobTitle: vacancy.job_title,
      jobSort: vacancy.sort,
      employer: vacancy.employerName,
      location : vacancy.original_location === "Work from Home / Remote / Nationwide" ? "Work from Home / Remote / Nationwide": vacancy.location_full,
      salary : Math.round(vacancy.annual_salary_min),
      invited : true,
      jobDetails:{}
    };
    if (vacancy.hourly_salary_min){
      body.salary = vacancy.hourly_salary_min + " per hour"
    }
    await new Promise(async (resolve) => {
      for (const element of userList){
        body.userId = element.userID
        body.jobDetails = {
          score_bp:element.score_bp,
          score_interest:element.score_interest,
          score_styles:element.score_styles,
          similar_skills: element.similar_skills,
          missing_skills: element.missing_skills
        }
        try {
          /*eslint-disable */
          let data = await post("/employer/job/user/status", body);
          /*eslint-enable */
        } catch (e) {
          logger.error("inviteListToVacancy():", e);
        }
      }
      resolve();
    });
    await dispatch(findAllStatuses(vacancy));
  }
}

export const setFavouritedCandidate = (userId, vacancy, isFavourited, freeCandidate, searchCandidate) => {
  return async dispatch => {
    if(searchCandidate){
      try {
        const data = await post("/employer/job/search/favourite", {
          vacancy:  vacancy,
          candidate: searchCandidate,
          isFavourited: isFavourited
        });
        return data
      } catch (e) {
        logger.error("setFavouritedCandidate Search Cand():", e);
      }
    }
    else{
      let body = {
        userId:  userId,
        jobId: vacancy.searchOnly || vacancy.isProject ? vacancy.sort : vacancy.job_id,
        isFavourited: isFavourited,
        isSearch: vacancy.searchOnly ? true : false,
        isProject: vacancy.isProject ? true : false
      };
      if (freeCandidate){
        body.freeCandidateDetails = {
          firstName : freeCandidate.firstName,
          lastName :freeCandidate.lastName,
          email: freeCandidate.email,
          telephone: freeCandidate.phoneNumber,
          data: freeCandidate
        }
      }
    
      try {
        const data = await post("/employer/job/user/favourite", body);
        return data
      } catch (e) {
        logger.error("setFavouritedCandidate():", e);
      }
    }
  };
};

export const setBulkFavouriteCandidates = (userIdList, vacancy) => {
  return async (dispatch, getState) => {
    const { vacancies:{ vacancyCandidates = []}  } = getState();

    let body = {
      userId:  null,
      jobId: vacancy.searchOnly || vacancy.isProject ? vacancy.sort : vacancy.job_id,
      isFavourited: true
    };
    await new Promise(async (resolve) => {
      for (const element of userIdList){
        const foundCand = vacancyCandidates.find((item) => item.userID === element.userID);
        body.userId = element
        if(!foundCand.favourited){
          await dispatch(setFavouritedCandidate(foundCand.userID, vacancy, true, foundCand.free_resume ? foundCand : false, foundCand.talentType === "Premium External Profiles"? foundCand : false))
        }
      }
      resolve();
    });
    await dispatch(findAllStatuses(vacancy));
  }
}

export const removeCandidatesFromVacancy = (userIdList, jobId, isPotential) => {
  return async dispatch => {
    let body = {
      userIdList:  userIdList,
      jobId: jobId
    };
  
    try {
      const data = post("/employer/job/user/remove", body);
      await dispatch({ type: REMOVE_VACANCIES_CANDIDATES, candidatesToRemove: userIdList,  isPotential: isPotential, jobId: jobId});
      return data
    } catch (e) {
      logger.error("removeCandidatesFromVacancy():", e);
    }
  };
};

export const restoreRemovedCandidates = (selectedVacancy) => {
  return async dispatch => {
    let body = {
      jobId: selectedVacancy.searchOnly || selectedVacancy.isProject ? selectedVacancy.sort : selectedVacancy.job_id
    };
  
    try {
      /*eslint-disable */
      const data = await post("/employer/job/user/removed/restore", body);
      /*eslint-enable */
    } catch (e) {
      logger.error("restoreRemovedCandidates():", e);
    }
  };
};

export function fetchVacancies(provider) {
  return async function(dispatch) {
    logger.info("fetchVacancies(): ");
    try {
      let data = await post("/employer/vacancies/get", {
        provider: provider
      });
      dispatch({ type: FETCH_VACANCIES, data: data });
    } catch (e) {
      logger.error("fetchVacancies():", e);
    }
  };
}

export function refreshVacancies(vacancies) {
  return async function(dispatch) {  
    dispatch({ type: FETCH_VACANCIES, data: {data:vacancies} });
  };
}

export const addNewVacancy = vacancy => {
  return async dispatch => {
    try {
      const removeOldSearch = vacancy.searchOnly ? true : false
      const data = await post("/employer/vacancies", { ...vacancy, id: undefined, sort: undefined, searchOnly: undefined });
      if (data.message) {
        return { success: false, message: data, error: data };
      }
      else{
        let jobDB_vac = _.cloneDeep(data.data)
        jobDB_vac.onet_styles = jobDB_vac.results.styles
        jobDB_vac.onet_interests = jobDB_vac.results.interests
        /*eslint-disable */
        const jobDB_data = await post("/jobs/query/vacancy_to_global", jobDB_vac);

        //
        if(removeOldSearch){  //this probably doenst happen any more 
          const transferShortList = await post("/employer/transferShortlist", {
            vacancy: data.data,
            search: vacancy
          });

          const removedSearch = await post("/employer/deleteSearch", vacancy);
          dispatch({ type: REMOVE_VACANCY, data: vacancy });
        }
        /*eslint-enable */
      }
      dispatch({ type: ADD_VACANCY, data: data.data });
      return { success: true };
    } catch (e) {
      throw e;
    }
  };
};

export const addNewSearch = newSearch => {
  return async dispatch => {
    try {
      const data = await post("/employer/createSearch", {
        ...newSearch, 
      });
      if (data && data.success){
        if(newSearch.isEdit){
          dispatch({ type: EDIT_VACANCY, data: data.data });  
        }
        else{
          dispatch({ type: ADD_VACANCY, data: data.data });
        }        
        return { success: true };
        
      }
      else{
        return { success: false, message: data, error: data };
      }
    } catch (e) {
      throw e;
    }
  };
};

export const editVacancy = vacancy => {
  return async dispatch => {
    try {
      const data = await patch("/employer/vacancies", { ...vacancy });
      if (data.message) {
        return { success: false, message: data, error: data };
      }
      else{
        let jobDB_vac = _.cloneDeep(data.data)
        jobDB_vac.onet_styles = jobDB_vac.results.styles
        jobDB_vac.onet_interests = jobDB_vac.results.interests
        /*eslint-disable */
        const jobDB_data = await post("/jobs/query/vacancy_to_global", jobDB_vac);
        /*eslint-enable */
      }
      dispatch({ type: EDIT_VACANCY, data: data.data });
      return { success: true };
    } catch (e) {
      return { success: false, message: e.message };
    }
  };
};

export const setVacancyStatus = (vacancy, status) => {
  return async (dispatch) => {
    try {
      /*eslint-disable */
      const body = await patch("/employer/vacancy/status/set", {
        jobId: vacancy.isProject ? vacancy.sort : vacancy.job_id,
        status: status,
        isProject: vacancy.isProject

      });
      if(!vacancy.isProject){
        await post("/jobs/query/update_vacancy_status", {
          id: vacancy.job_id,
          status: status.charAt(0).toUpperCase() + status.slice(1)
        });
      }
      vacancy.status = status
      dispatch({ type: EDIT_VACANCY, data: vacancy });
    } catch (e) {
      logger.error("setVacancyStatus():", e);
    }
  }
}

export const getVacancyDetails = (vacancy) => {
  return async (dispatch) => {
    try {
      if(!(vacancy.searchOnly || vacancy.isProject)){
        const data = await patch("/employer/vacancy/details/get", {
          jobId: vacancy.job_id
        });
        
        if (data){
          vacancy.status = data.status ? data.status : "open"
        }
        else{
          vacancy.status = "open"
        }
        dispatch({ type: EDIT_VACANCY, data: vacancy });
      }
    } catch (e) {
      logger.error("getVacancyDetails():", e);
    }
  }
}

export function fetchCandidates(selectedVacancy, mineGlobally, includeInternalProvider){
  return async function (dispatch, getState) {
    const { portaldetails: { user:{ organisation = ""}, orgdetails={}  } } = getState();

    logger.info("fetchCandidates(): ");
    if (selectedVacancy){
      dispatch({ type: UPDATE_SNACKBAR, data: "Searching for Skillsminer Profiles" });
      const onlySkills = selectedVacancy.occupation.length === 0 ? true : false
      //get blacklist
      let removedUsers = []
      let profileUrls = {}
      let jobID = selectedVacancy.searchOnly || selectedVacancy.isProject ? selectedVacancy.sort : selectedVacancy.job_id
      try {
        const data = await post("/employer/job/user/removed/get", {
          jobId: jobID
        });
        if(data){
          removedUsers = data.userList
        }
      } catch (e) {
        logger.error("fetchRemovedCandidates error():", e);
      }

      try {
        const { jobs } = await post("/jobs/query/reverse_mining", {
          ...selectedVacancy,
          occupation: onlySkills ? false : selectedVacancy.occupation,
          mineGlobally: mineGlobally,
          includeInternalProvider:includeInternalProvider,
          results: selectedVacancy.results
        });
        if (jobs) {
          const idList = [...new Set(jobs.map((item) => item.userID))]
          if(idList && idList.length > 0){
            profileUrls = await post("/employer/job/user/images", 
              {idList: idList});
          }
        }
        dispatch({ type: FETCH_VACANCIES_CANDIDATES, data: jobs, jobID: jobID, removedUsers: removedUsers, organisation: organisation, provider: selectedVacancy.provider, profileUrls: profileUrls, orgdetails: orgdetails });
        dispatch({ type: UPDATE_SNACKBAR, data: "Searching for External Profiles" });
        try {
          //now do search
          const isRemote = selectedVacancy.location_full === "1234567891234567891" ? true : false
          const request_body = {
            job_title: selectedVacancy.job_title,
            location: isRemote ? selectedVacancy.location_full : selectedVacancy.location_full.includes("Greater London") ? "London" : selectedVacancy.original_location,
            postcode: isRemote ? "" : selectedVacancy.location_full.split(",")[2].replace(" ", ""),
            lat: selectedVacancy.lat ? selectedVacancy.lat : "52.065299",
            lon: selectedVacancy.lon ? selectedVacancy.lon : "-0.187183" ,
            occupation: onlySkills ? [] : [selectedVacancy.occupation],
            required_skills: selectedVacancy.skills_required || []
          }

          const monsterSearch = await post(onlySkills ? "/jobs/query/candidate_skills_search_monster": "/jobs/query/candidate_search_monster", request_body);
          if(monsterSearch && monsterSearch.jobs){
            dispatch({ type: FETCH_VACANCIES_CANDIDATES_MONSTER, data: monsterSearch.jobs, jobID, removedUsers, organisation: organisation, provider: selectedVacancy.provider, orgdetails: orgdetails  });
          }
        } catch (e) {
          logger.error("fetchCandidates SEARCH error():", e);
        } 
        dispatch({ type: UPDATE_SNACKBAR, data: "" });
        
      } catch (e) {
        logger.error("fetchCandidates():", e);
        dispatch({ type: FETCH_VACANCIES_CANDIDATES, data: false });
      }
    }
    else{
      console.log("close")
      dispatch({ type: FETCH_VACANCIES_CANDIDATES, data: false });
    }
  };
};

export const fetchDetailedCandidate = (candidateID, selectedVacancy, isPotential, candidateData) => {
  return async (dispatch) => {
    logger.info("fetchDetailedCandidate(): ");
    try {
      let data = false
      if(candidateData){
        data = candidateData
      }
      else{
        data = await post("/employer/job/user/details", {
          candidateID: candidateID,
          skills: selectedVacancy.required_skills || []
        });
      }
      dispatch({type: SET_CANDIDATE_DETAILS, data: data, selectedVacancy, isPotential});
      if(data && data.occupationSkills && data.occupationSkills.length){
        dispatch(fetchSkillTypes(data.occupationSkills.flatMap(occ => occ.skills.map(skill => (skill.name)))))
      }
    } catch (e) {
      logger.error("fetchDetailedCandidate():", e);
    }
  }
}


export const findAllStatuses = (vacancy, purge) => {
  return async (dispatch) => {
    try {
      if(purge){
        dispatch({type: FIND_VACANCIES_STATUSES, shortList: [], removedUsers:[], globalUnlocked: [], profileUrls: {}});
      }
      const jobId = vacancy.searchOnly || vacancy.isProject ? vacancy.sort : vacancy.job_id
      if(jobId){
        let statusData = await post("/employer/job/status", {
          isProject: vacancy.isProject || false,
          jobId:  jobId,
          skills: vacancy.skills_required || []	
        });
        let removedUsers = []
        let profileUrls = {}
        try {
          const data = await post("/employer/job/user/removed/get", {
            jobId: jobId
          });
          if(data){
            removedUsers = data.userList
          }
        } catch (e) {
          logger.error("fetchRemovedCandidates error():", e);
        }
        if(statusData && statusData.shortList && statusData.shortList.length > 0){
          profileUrls = await post("/employer/job/user/images", 
            {idList: [...new Set(statusData.shortList.map((item) => item.id))]});
        }

        dispatch({type: FIND_VACANCIES_STATUSES, shortList: statusData.shortList, removedUsers, globalUnlocked: statusData.globalUnlocked, profileUrls: profileUrls});
        dispatch(fetchSkillTypes(vacancy.skills_required))
      }
      else{
        dispatch({type: FIND_VACANCIES_STATUSES, shortList: [], removedUsers:[], globalUnlocked: [], profileUrls: {}});
      }
    } catch (e) {
      logger.error("findAllStatuses():", e);
    }
  }
}



export const getVacancyById = (jobId) => {
  return async (dispatch) => {
    try {
      let data = await post("/employer/vacancies/getById", {
        jobId: jobId 
      });
     
      dispatch({type: SET_VACANCY_BY_ID, data: data});
    } catch (e) {
      logger.error("getVacancyById():", e);
    }
  }
}

export const deleteSearch = search => {
  return async dispatch => {
    try {
      const data = await post("/employer/deleteSearch", search);
      if (data && data.success){
        dispatch({ type: REMOVE_VACANCY, data: search });
        return { success: true };
      }
      else{
        return { success: false };
      }
    } catch (e) {
      throw e;
    }
  };
};

export const unlockCandidate = (candidate, selectedSearch, source, newVersion) => {
  return async function (dispatch, getState) {
    logger.info("unlockCandidate(): ");
    const { vacancies: { searchShortlist=[], searchCandidates  } } = getState();
    try {
      if(newVersion){
        let response = await post("/employer/vacancies/shortlist/unlock", {
          candidate: candidate,
          vacancy: selectedSearch
        });
        if (response && response.success){
          if (response.data){
            await dispatch(findAllStatuses(selectedSearch))
            await dispatch(fetchDetailedCandidate(candidate.userID, selectedSearch, source === "viewVacancy" ? true : false, response.data))
            return false
          }
          else{
            return response.message
          }
        }
        else{
          return "An error has occurred"
        }
      }
      else{
        let response = await post("/employer/searches/shortlist/unlock", {
          candidate: candidate,
          search: selectedSearch
        });
        if (response && response.success){
          if (response.data){
            await dispatch({ type: UPDATE_SEARCH_SHORTLIST, candidate: response.data, shortlist:searchShortlist, searchCandidates:searchCandidates, unlocked:true });
            if (source === "reviewSearchCandidates"){
              dispatch({ type: FILTER_SEARCH_CANDIDATES, selectedSearch: selectedSearch});
            }
            return false
          }
          else{
            return response.message
          }
        }
        else{
          return "An error has occurred"
        }
      }
    } catch (e) {
      logger.error("unlockCandidate():", e);
      return e
    }
  };
};

export const getCVLink = (candidate) => {
  return async function (dispatch) {
    logger.info("getCVLink(): ");
    try {
        console.log(candidate)
        const genResponse = await post(
          "/pdf-service/monster-pdf",
          { id: candidate.free_resume || candidate.talentType === "Premium External Profiles" ? candidate.userID : candidate.sort, freeVersion: candidate.free_resume },
          { timeout: 1200000 } // This timeout option might need to be handled by your wrapper if not already
        );
        if (genResponse && genResponse.success){
          const getUrlResult = await getUrl({
            path: ({identityId}) => `monsterpdfs/${candidate.free_resume || candidate.talentType === "Premium External Profiles" ? candidate.userID : candidate.sort}.pdf`,
          });
          const s3Url = getUrlResult.url.href;
          const blob = await fetch(s3Url, { method: "get" });
          return {success: true, data: await blob.blob()}
        }
      }
    catch (e) {
      logger.error("unlockCandidate():", e);
    }
    return {success: false}
  };
};

export const fetchBotTemplates = () => {
return async function(dispatch) {
  logger.info("fetchTemplates(): ");
  try {
    let { data } = await post("/employer/searches/getTemplates", {});
    if (data){
      dispatch({ type: FETCH_BOT_TEMPLATE, baseTemplate: data.baseTemplate, toggleQuestions: data.toggleQuestions, userTemplates: data.userTemplates, start_text: data.start_text, end_text: data.end_text, end_text_escape: data.end_text_escape, emailMain: data.emailMain, emailPromotional: data.emailPromotional});
    }
  } catch (e) {
    logger.error("fetchTemplates():", e);
  }
};
}


export const submitTemplateItem = (newTemplate, isEdit) => {
  return async function (dispatch) {
    logger.info("submitTemplateItem(): ");
    try {
      const data = await post("/employer/createTemplate", {
        ...newTemplate, 
        isEdit: isEdit
      });
      if (data && data.success){
        if (isEdit){
          dispatch({ type: EDIT_TEMPLATE, data: data.data });
        }
        else{
          dispatch({ type: ADD_TEMPLATE, data: data.data });
        }
        return { success: true };
      }
      else{
        return { success: false };
      }
    } catch (e) {
      logger.error("submitTemplateItem():", e);
    }
  }
}

export const deleteTemplate= template => {
  return async (dispatch, getState) => {
    try {
      const { vacancies: { searches=[]  } } = getState();

      for (const search of searches){
        if(search.templateSort && search.templateSort == template.sort){
          return { success: false, message: "Delete template failed.  Template in use by active search" };
        }
      }

      const data = await post("/employer/deleteTemplate", template);
      if (data && data.success){
        dispatch({ type: REMOVE_TEMPLATE, data: template });
        return { success: true };
      }
      else{
        return { success: false };
      }
    } catch (e) {
      throw e;
    }
  };
};

export const assignTemplateScript = (search, template) => {
  return async function (dispatch) {
    logger.info("assignTemplateScript(): ");
    try {
      const data = await post("/employer/searches/assignTemplate", {
        ...search, 
        templateName: template.title,
        templateSort:template.sort
      });
      if (data && data.success){
        dispatch({ type: EDIT_VACANCY, data: data.data });
        return { success: true };
      }
      else{
        return { success: false };
      }
    } catch (e) {
      throw e;
    }
  }
}

export const autoCompleteV2 = (text) => {
  return async function (dispatch) {
    logger.info("occupationAutoComplete(): ");
    try {
      const data = await post("/nlu/occupationAutoComplete", {
        text: text, 
        dualType: false
      }, {}, true);
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      // console.log(e)
    }
    try {
      const data = await post("/nlu/occupationAutoCompleteFallback", {
        text: text, 
        dualType: false
      });
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      throw e;
    }
    return {
      directMatches: [],
      closeMatches: []
    };
  }
}


export const autoCompleteV2Skill = (text) => {
  return async function (dispatch) {
    logger.info("skillAutoComplete(): ");
    try {
      const data = await post("/nlu/skillAutoComplete", {
        text: text, 
        dualType: false
      }, {}, true);
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      // console.log(e)
    }
    try {
      const data = await post("/nlu/skillAutoCompleteFallback", {
        text: text, 
        dualType: false
      });
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      throw e;
    }
    return {
      directMatches: [],
      closeMatches: []
    };
  }
}

export const autoCompleteLocationV2 = (text) => {
  return async function (dispatch) {
    logger.info("autoCompleteLocationV2(): ");
    try {
      const data = await post("/nlu/locationAutoComplete", {
        text: text
      }, {}, true);
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      // console.log(e)
    }
    try {
      const data = await post("/nlu/locationAutoCompleteFallback", {
        text: text
      });
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      throw e;
    }
    return {
      directMatches: [],
      closeMatches: []
    };
  }
}


export const getLocationDetails = (text) => {
  return async function (dispatch) {
    logger.info("getLocationDetails(): ");
    try {
      const data = await post("/nlu/getLocationDetails", {
        text: text
      }, {}, true);
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      // console.log(e)
    }
    try {
      const data = await post("/nlu/getLocationDetailsFallback", {
        text: text
      });
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      throw e;
    }
  }
}

export const autoCompleteSkill = (text) => {
  return async function (dispatch) {
    logger.info("autoCompleteSkill(): ");
    try {
      const data = await post("/nlu/skill", {
        text: text, 
        dualType: false
      }, {}, true);
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      // console.log(e)
    }
    try {
      const data = await post("/nlu/fallbackskill", {
        text: text, 
        dualType: false
      });
      if (data && data.response){
        return data.response
      }
    } catch (e) {
      
      throw e;
    }
    return [];
  }
}

//pre qual contact
export const contactCandidate = (candidate, selectedSearch, source, newVersion) => {
  return async function (dispatch, getState) {
    logger.info("contactCandidate(): ");
    const { vacancies: { searchShortlist=[], searchCandidates  } } = getState();
    const isInternalCandidate = ["Community CV's", "Premium External Profiles"].includes(candidate.talentType) ? false : true
    try {

      let response = await post("/employer/searches/shortlist/contact", {
        candidate: candidate,
        search: selectedSearch,
        isVacancy: (selectedSearch.searchOnly || selectedSearch.isProject) ? false : true,
        isFreeCandidate: candidate.free_resume ? true : false,
        isInternalCandidate: isInternalCandidate,
      });
      if (response && response.success){
        if (response.data){
          await dispatch(findAllStatuses(selectedSearch))
          await dispatch(fetchDetailedCandidate(candidate.userID, selectedSearch, source === "viewVacancy" ? true : false, isInternalCandidate ? false : response.data))
          return false
        }
        else{
          return response.message
        }
      }
      else{
        return "An error has occurred"
      }
    } catch (e) {
      logger.error("contactCandidate():", e);
      return e
    }
  };
};

export const setColumnViewPrefs = (view, values) => {
  return async function (dispatch) {
    logger.info("assignTemplateScript(): ");
    try {
      const data = await post("/employer/vacancy/viewprefs", {
        view: view,
        values: values,
      });
    } catch (e) {
      throw e;
    }
  }
}

export const getColumnViewPrefs = async (dispatch) => {
  logger.info("getColumnViewPrefs(): ");
  try {
    const data = await get("/employer/vacancy/viewprefs", {});
    if (data){
      await dispatch({ type: GET_VIEW_PREFS, data: data});
      return data
    }
  } catch (e) {
    throw e;
  }
}

// /payments/checkout/monstercredits
export const bundleCheckout = (creditOption) => {
  return async (dispatch) => {
    try {
      const checkoutResponse = await post("/user/bundleCheckout", {
        credits: creditOption
      });
      if (checkoutResponse){
        if(checkoutResponse.success && checkoutResponse.session){
          return {url : checkoutResponse.session.url}
        }
        else if(checkoutResponse.error){
          return {error : checkoutResponse.session.url}
        }
      }
    } catch (e) {
      logger.error("bundleCheckout():", e);
    }
    return {error : "Unknown Error"}
  }
}

export const setUserProjectUtilisation = (userID, project, allocation) => {
  return async (dispatch) => {
    try {
      await post("/employer/project/set/utilisation", {
        userID: userID,
        projectID: project.sort,
        startDate: project.startDate,
        endDate: project.endDate,
        newHours: allocation
      });
      await dispatch(findAllStatuses(project));
    } catch (e) {
      logger.error("setUserProjectUtilisation():", e);
    }
  }
}

export const getUserAvailability = (userID, project) => {
  return async (dispatch) => {
    try {
      const data = await post("/employer/user/get/utilisation", {
        userID: userID,
        excludedProject: project.sort,
        startDate: project.startDate,
        endDate: project.endDate
      });
      if(data.success){
        dispatch({type: SET_USER_AVAILABILITY, weeklyWorkingHours: data.weeklyWorkingHours, durationUtilisationHours: data.durationUtilisationHours, userID: userID});
      }      
    } catch (e) {
      logger.error("getUserAvailability():", e);
    }
  }
}

export const generateSkillIndexs = (skillTypeMap, skills) => {
  return (dispatch) => {
    try {
      let roleData = {"digital skill": 0, "green skill": 0, "automatable skill": 0}
      if(skills.length){
        for(const skillType of Object.keys(roleData)){
          const allFilteredSkills = skills.filter((item) => skillTypeMap[item] && skillTypeMap[item].includes(skillType));
          roleData[skillType] = Math.round((allFilteredSkills.length / skills.length) * 100)
        }
      }
      return {roleName: "Index Comparison", ...roleData}
    } catch (e) {
      console.log(e)
      return false
    }
  }
}